import React, { useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartEvent,
} from "chart.js";
import { Box, Button, Typography } from "@mui/material";
import { t } from "i18next";
import { AccuracyData } from "../@types";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface Props {
  data: AccuracyData[];
  setSelectedEpoch: (epoch: AccuracyData | null) => void;
}

const LineChartComponent: React.FC<Props> = ({ data, setSelectedEpoch }) => {
  const chartData = {
    labels: data.map((item) => item.epoch.toString()), // x축 레이블
    datasets: [
      {
        label: "정확도",
        data: data.map((item) => item.accuracy * 100), // y축 데이터 (퍼센트로 변환)
        borderColor: "#3b82f6",
        tension: 0.1,
        pointRadius: 5,
        pointHoverRadius: 8,
        hitRadius: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        title: {
          display: true,
          text: "정확도 (%)",
        },
        min: 0,
        max: 100,
      },
      x: {
        title: {
          display: true,
          text: "Epoch",
        },
      },
    },
    onClick: (event: ChartEvent, elements: any[]) => {
      if (elements.length > 0) {
        const dataIndex = elements[0].index; // 클릭한 포인트의 인덱스
        setSelectedEpoch(data[dataIndex]);
      }
    },
  };

  useEffect(() => {
    setSelectedEpoch(null);
  }, [data]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "400px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Line data={chartData} options={options} />
    </Box>
  );
};

export default LineChartComponent;
